module.exports = __webpack_public_path__ + "static/media/sass.6cf4d555.png";